import React from 'react';
import { CardTitle, Card, CardText } from 'material-ui';
import { translate as t } from 'admin-on-rest';
import FormInput from 'admin-on-rest/lib/mui/form/FormInput';

const styles = {
  card: {
    marginBottom: '1em',
  },
  cardTitle: {
    paddingBottom: 0,
  },
};

export const Section = t((props) => {
  const { translate, title, subtitle, children } = props;
  return (
    <Card style={styles.card}>
      {title && <CardTitle style={styles.cardTitle} title={title ? translate(title, { smart_count: 2 }) : 'Section title'} subtitle={subtitle ? translate(subtitle) : null} />}
      <CardText>
        {React.Children.map(
          children,
          (input) => (input ? <FormInput {...props} input={input} /> : null)
        )}
      </CardText>
    </Card>
  );
});

export default Section;
